/**
 * Shared chrome for the requester `Avatar` across the Requests domain (inbox rows
 * + detail panel): 30px, borderless, brand-blue fill, bold 11px white initials.
 */
export const REQUESTER_AVATAR_CLASS = [
  '!h-[30px] !w-[30px] !min-h-[30px] !min-w-[30px] !border-0 bg-[#2B7FFF]',
  'text-white [&>span]:text-[11px] [&>span]:font-bold [&>span]:leading-none [&>span]:text-white',
].join(' ');
